import React from "react";
import { heroTicker } from "../content/landingContent";
import { useContentBoolean, useContentList, useContentField } from "../lib/useContent";

// Franja premium entre el Hero y la siguiente sección: aprovecha el espacio
// blanco con un ticker horizontal de desplazamiento continuo (marquee vía
// CSS/Tailwind, sin la etiqueta <marquee> obsoleta). Contenido y colores
// editables desde /content-admin (sección "2b. Franja animada").
export const HeroTicker: React.FC = () => {
  const enabled = useContentBoolean("heroTicker.enabled", heroTicker.enabled);
  const items = useContentList("heroTicker.textList", heroTicker.items);
  const bgColor = useContentField("heroTicker.bgColor", heroTicker.bgColor);
  const textColor = useContentField("heroTicker.textColor", heroTicker.textColor);

  if (!enabled || items.length === 0) return null;

  const track = [...items, ...items];

  return (
    <div
      data-testid="hero-ticker-section"
      className="relative overflow-hidden py-2.5 sm:py-3"
      style={{ backgroundColor: bgColor }}
    >
      <div
        className="hero-ticker-track flex whitespace-nowrap animate-marquee motion-reduce:animate-none"
        aria-hidden="true"
      >
        {track.map((item, i) => (
          <span
            key={i}
            data-testid={`hero-ticker-item-${i}`}
            className="font-display font-semibold text-[10px] sm:text-xs tracking-[0.18em] mx-4 sm:mx-6 flex items-center gap-4 sm:gap-6 shrink-0"
            style={{ color: textColor }}
          >
            {item}
            <span className="text-motor-red">•</span>
          </span>
        ))}
      </div>
      <span className="sr-only">{items.join(" — ")}</span>
    </div>
  );
};
